import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { INSURANCE_OPTIONS } from "@/data/products";
import { Check } from "lucide-react";

// Short lead-capture form used on the homepage & product pages.
export default function QuoteForm({ presetType, compact }) {
  const nav = useNavigate();
  const [f, setF] = useState({ first_name: "", last_name: "", phone: "", email: "", zip_code: "" });
  const [types, setTypes] = useState(presetType ? [presetType] : []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const toggle = (t) => setTypes(types.includes(t) ? types.filter((x) => x !== t) : [...types, t]);

  const start = () => {
    const params = new URLSearchParams(window.location.search);
    nav("/quote", { state: { lead: f, types: types.length ? types : (presetType ? [presetType] : []),
      utm: { utm_source: params.get("utm_source"), utm_medium: params.get("utm_medium"), utm_campaign: params.get("utm_campaign") } } });
  };

  const input = "w-full h-12 px-4 rounded-sm border border-slate-300 bg-white text-[#0B1E36] focus:outline-none focus:ring-2 focus:ring-[#C5A059] transition-shadow";

  return (
    <div className="bg-white border border-slate-200 rounded-sm p-6 sm:p-8 shadow-xl text-[#0B1E36]" data-testid="quote-form">
      <div className="mb-5">
        <p className="text-xs uppercase tracking-[0.2em] text-[#C5A059] font-bold">Fast · Free · No Obligation</p>
        <h3 className="font-display text-2xl font-bold mt-1">See How Much You Could Save</h3>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <input className={input} placeholder="First Name" value={f.first_name} onChange={set("first_name")} data-testid="qf-first-name" />
        <input className={input} placeholder="Last Name" value={f.last_name} onChange={set("last_name")} data-testid="qf-last-name" />
        <input className={input} placeholder="Phone" value={f.phone} onChange={set("phone")} data-testid="qf-phone" />
        <input className={input} placeholder="ZIP Code" value={f.zip_code} onChange={set("zip_code")} data-testid="qf-zip" />
        <input className={`${input} col-span-2`} placeholder="Email" value={f.email} onChange={set("email")} data-testid="qf-email" />
      </div>
      {!presetType && (
        <div className="mt-5">
          <p className="text-sm font-semibold mb-2">What do you need insurance for?</p>
          <div className="flex flex-wrap gap-2">
            {INSURANCE_OPTIONS.map((o) => (
              <button key={o} type="button" onClick={() => toggle(o)} data-testid={`qf-type-${o.replace(/[^a-z]/gi,'-').toLowerCase()}`}
                className={`text-sm px-3 py-2 rounded-sm border transition-colors flex items-center gap-1 ${types.includes(o) ? "bg-[#0B1E36] text-white border-[#0B1E36]" : "bg-white border-slate-300 hover:border-[#C5A059]"}`}>
                {types.includes(o) && <Check size={14} />} {o}
              </button>
            ))}
          </div>
        </div>
      )}
      <button onClick={start} className="mt-6 w-full bg-[#C5A059] text-[#0B1E36] font-bold text-base h-14 rounded-sm hover:bg-[#0B1E36] hover:text-white transition-colors" data-testid="qf-start-button">
        {presetType ? "GET A FREE QUOTE" : "START MY FREE QUOTE"}
      </button>
      <p className="text-[11px] text-slate-500 mt-3 leading-relaxed">
        By submitting, you agree to be contacted by Keystone Shield Insurance about your insurance inquiry by phone, text, or email. Consent is not a condition of purchase.
      </p>
    </div>
  );
}
